import en from "./en";

const si = {
    product_identification:'Enotna identifikacijska oznaka tipa proizvoda:',
    manufacturer: 'Proizvajalec in pooblaščeni zastopnik',
    product_type:'Izberite vrsto proizvoda',

    core_type:'Izberite vrsto jedra:',

    application:'Predvidena uporaba',

    system:'Sistem(-i) ocenjevanja in preverjanja nespremenljivosti lastnosti:',

    harmonized_standard:'Harmonizirani standard:',

    notified_body:'Priglašeni organ(i):',

    technical_document:'Evropski dokument o tehnični oceni:',

    fire_and_resistance:'II) Odziv na ogenj:',

    fire_reaction:'Odziv na ogenj',

    declaration:'Izjava o lastnostih',

    face_back_material:'Material, zunanja/notranja obloga',

// MAIN SECTIONS
    basic_information: 'Splošne informacije',
    fire_resistance: 'Odziv na odpornost proti požaru',
    material: 'Material',
    characteristics: 'Bistvene lastnosti',

// TABLE HEADERS
    characteristic: 'Bistvene lastnosti',
    value: 'Vrednost',
    standard: 'Dokument / Standard',

// CHARACTERISTICS
    u_value:
        'VI) Koeficient toplotne prehodnosti U-vrednost',

    lambda:
        'VII) Koeficient toplotne prevodnosti jedra',

    mechanical_resistance:
        'VIII) Mehanska odpornost',

    zatezna_cvrstoca:
        'a) Natezna trdnost',

    modul_zatezanja:
        'b) Natezni modul',

    zatezna_temp:
        'c) Natezna modul pri povišani temperaturi',

    modul_temp:
        'd) Natezni modul pri povišani temperaturi',

    pritisna:
        'e) Tlačna trdnost',

    modul_pritiska:
        'f) Tlačni modul',

    smicanje:
        'g) Strižna trdnost',

    smicanje_dugotrajno:
        'h) Zmanjšana dolgoročna strižna trdnost',

    modul_smicanja:
        'i) Strižni modul',

    puzanje_2000:
        'j) Koeficient lezenja t=2.000h',

    puzanje_100000:
        'k) Koeficient lezenja t=100.000h',

    l_group:
        'l) Nosilnost upogibnega momenta enostavno podprtega panela',

    l_pozitivno:
        'Pozitivno',

    l_pozitivno_temp:
        'Pozitivno, povišana temperatura',

    l_negativno:
        'Negativno',

    l_negativno_temp:
        'Negativno, povišana temperatura',

    m_group:
        'm) Razmerje med upogibnim momentom in reakcijami podpor',

    m_kapacitet:
        'Nosilnost upogibnega momenta',

    m_pozitivno:
        'Pozitivno',

    m_pozitivno_temp:
        'Pozitivno, povišana temperatura',

    m_negativno:
        'Negativno',

    m_negativno_temp:
        'Negativno, povišana temperatura',

    n_group:
        'n) Gubna napetost - zgornja pločevina',

    n_u_polju:
        'V polju',

    n_u_polju_temp:
        'V polju, povišana temperatura',

    n_srednji_oslonac:
        'Na vmesni podpori',

    n_srednji_oslonac_temp:
        'Na vmesni podpori, povišana temperatura',

    o_group:
        'o) Gubna napetost - spodnja pločevina',

    o_u_polju:
        'V polju',

    o_srednji_oslonac:
        'Na vmesni podpori',

    ix_pozar:
        'IX) Zunanja izpostavljenost požaru',

    x_voda:
        'X) Vodotesnost',

    xi_zrak:
        'XI) Zrakotesnost',

    xii_para:
        'XII) Prepustnost vodne pare',

    xiii_zvuk:
        'XIII) Zvočna izolacija pred zračnim hrupom',

    xiv_apsorpcija:
        'XIV) Absorpcija zvoka',

    xv_trajnost:
        'XV) Trajnost',

    xvi_test:
        'XVI) Preskus pritrdil',

    dokumentacija:
        '8. Ustrezna tehnična dokumentacija in/ali posebna tehnična dokumentacija',

    signed_for: 'Podpisano za in v imenu proizvajalca:',

    footer_declaration:
        'Lastnosti zgoraj navedenega proizvoda so skladne z nizom deklariranih lastnosti. Ta izjava o lastnostih je izdana v skladu z Uredbo o gradbenih proizvodih št. 305/2011 pod izključno odgovornostjo zgoraj navedenega proizvajalca.\n' +
        '\n' +
        'Zmogljivost zgoraj navedenega proizvoda je skladna z nizom deklariranih lastnosti. Ta izjava o lastnostih je izdana v skladu z Uredbo (EU) št. 305/2011 pod izključno odgovornostjo zgoraj navedenega proizvajalca.\n' +
        '\n' +
        '1 Dokumentacija o preskusu požarne odpornosti se izda na zahtevo kupca\n' +
        '2 Nosilnosti upogibnega momenta so podane za debelino pločevine 0,4/0,4\n' +
        '3 V skladu z EN-14509, EN-13165 in uporabljenimi materiali je naslednja lastnost potrjena brez preskušanja\n',

    npd_translation:
        'Lastnost ni deklarirana',

    thickness: 'Debelina',

    general_manager: 'General Manager',

    toplotna_otpornost:
        'Toplotna upornost',

    toplotna_provodljivost:
        'Toplotna prevodnost',

    tolerancije_debljine_group:
        'V) Tolerance debeline',

    kategorija_tolerancije:
        'Kategorija tolerance',

    plus_tolerancija:
        'Pozitivna toleranca [+mm]',

    minus_tolerancija:
        'Negativna toleranca [-mm]',

    reakcija_na_vatru_group:
        'VI) Reakcija na ogenj',

    performance_class:
        'Razred zmogljivosti',

    smoke_classification:
        'Klasifikacija razvoja dima',

    flaming_droplets:
        'Klasifikacija gorečih kapljic',

    izdrzljivost_group:
        'VIII) Trajnost',

    dimenzionalna_stabilnost:
        'Dimenzijska stabilnost',

    deformacija_pod_opterecenjem:
        'Deformacija pod obremenitvijo',

    cvrstoca_na_pritisak:
        'IX) Tlačna trdnost (CS(10/Y)100, NPD)',

    cvrstoca_na_zatezanje:
        'X) Natezna trdnost',

    vodopropusnost_group:
        'XII) Vodoprepustnost',

    kratkotrajna_apsorpcija_vode:
        'Kratkotrajna absorpcija vode',

    dugotrajna_djelimicna_apsorpcija:
        'Dolgotrajna delna absorpcija vode',

    dugotrajna_potpuna_apsorpcija:
        'Dolgotrajna popolna absorpcija vode',

    ravnost_nakon_kvasenja:
        'Ravnost po omočenju',

    paropropusnost:
        'XIII) Paroprepustnost',

    indeks_apsorpcije_zvuka:
        'XIV) Indeks absorpcije zvoka',

    ispustanje_opasnih_materija:
        'XV) Sproščanje nevarnih snovi',

    kontinuirano_uzareno_izgaranje:
        'XVI) Neprekinjeno tleče izgorevanje',

    application_14509_wall:
        'Kovinsko obložen termoizolacijski panel za uporabo v gradbeništvu - Stene in stenske obloge',

    application_14509_roof:
        'Kovinsko obložen termoizolacijski panel za uporabo v gradbeništvu - Strehe in strešne obloge',

    application_14509_coldroom:
        'Kovinsko obložen termoizolacijski panel za uporabo v gradbeništvu - Hladilni panel',

    application_13165:
        'Toplotnoizolacijske plošče za uporabo v gradbeništvu - Izolacija tal, sten in streh',

    laminirana_folija:
        'Laminirana folija',
}

export default si